import { gql } from '@apollo/client';

export const DELETE_ROOM_RENTAL = gql`
  mutation DeleteRoomRental($input: DeleteRoomRentalInput!) {
    deleteRoomRental(input: $input)
  }
`;
